import { render } from "./ProjectProposal.vue?vue&type=template&id=b80b0a7c"
import script from "./ProjectProposal.vue?vue&type=script&lang=js"
export * from "./ProjectProposal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__